import { Action } from 'redux'
import { CountryCode } from '../../../i18n/countryCodes'
import { UserAccountActions } from '../../../reducers/userAccount/actionNames'

const switchLanguage = (
  language: CountryCode,
  reload = true,
): ISwitchLanguage => ({
  language,
  reload,
  type: UserAccountActions.SwitchLanguage,
})

const languageChanged = (
  language: CountryCode,
  reload = true,
): ILanguageSwitched => ({
  language,
  reload,
  type: UserAccountActions.LanguageSwitched,
})

export { switchLanguage, languageChanged }

export interface ISwitchLanguage
  extends Action<UserAccountActions.SwitchLanguage> {
  language: CountryCode
  reload?: boolean
}

export interface ILanguageSwitched
  extends Action<UserAccountActions.LanguageSwitched> {
  language: CountryCode
  reload?: boolean
}
